import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import commonEN from '../locales/en-US/common.json';
import companyEN from '../locales/en-US/company.json';
import consultantEN from '../locales/en-US/consultant.json';
import auditorEN from '../locales/en-US/auditor.json';
import adminEN from '../locales/en-US/admin.json';
import paymentsEN from '../locales/en-US/payments.json';
import errorsEN from '../locales/en-US/errors.json';

// Supported languages configuration
export const supportedLanguages = {
  'en-US': { name: 'English', nativeName: 'English', flag: '🇺🇸', available: true },
  'ms-MY': { name: 'Malay', nativeName: 'Bahasa Melayu', flag: '🇲🇾', available: false },
  'zh-CN': { name: 'Chinese (Simplified)', nativeName: '简体中文', flag: '🇨🇳', available: false },
  'zh-TW': { name: 'Chinese (Traditional)', nativeName: '繁體中文', flag: '🇹🇼', available: false },
  'ar-SA': { name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', available: false },
} as const;

export type SupportedLanguage = keyof typeof supportedLanguages;

// Default language
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en-US';

// Fallback language
export const FALLBACK_LANGUAGE: SupportedLanguage = 'en-US';

// Initialize i18next
i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      'en-US': {
        common: commonEN,
        company: companyEN,
        consultant: consultantEN,
        auditor: auditorEN,
        admin: adminEN,
        payments: paymentsEN,
        errors: errorsEN,
      },
      // Future languages will be added here:
      // 'ms-MY': { common: commonMS, company: companyMS, ... },
      // 'zh-CN': { common: commonZH, company: companyZH, ... },
      // 'ar-SA': { common: commonAR, company: companyAR, ... },
    },
    lng: DEFAULT_LANGUAGE, // Default language
    fallbackLng: FALLBACK_LANGUAGE, // Fallback language
    defaultNS: 'common', // Default namespace
    fallbackNS: 'common', // Fallback namespace

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Debug mode (disable in production)
    debug: import.meta.env.DEV,

    // React options
    react: {
      useSuspense: true, // Enable suspense for translations
    },
  });

export default i18n;
